
[
  {
    "id": "GET-POS-L1-001",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Wat is de waarde van de 8 in het getal 78.432?",
    "options": [
      "80",
      "800",
      "8.000",
      "80.000"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "positiewaarde",
    "familyId": "GET-POS-WAARDE",
    "explanation": "De 8 staat op de plek van de duizendtallen. Dus de 8 betekent 8.000.",
    "distractorExplanations": {
      "0": "Dat zijn de tientallen (de 3).",
      "1": "Dat zijn de honderdtallen (de 4).",
      "3": "Dat zijn de tienduizendtallen (de 7)."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Positiewaarde",
        "content": "Kijk naar de plek: Tienduizendtallen - Duizendtallen - Honderdtallen - Tientallen - Eenheden.",
        "icon": "hash"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-VER-L1-001",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Welke breuk is evenveel als 0,75?",
    "options": [
      "$\\frac{1}{2}$",
      "$\\frac{1}{4}$",
      "$\\frac{3}{4}$",
      "$\\frac{2}{5}$"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_decimaal",
    "familyId": "GET-BREUK-DECIMAAL",
    "explanation": "0,75 is driekwart. Dat schrijf je als $\\frac{3}{4}$. Denk maar aan een euro: 75 cent is 3 kwartjes.",
    "distractorExplanations": {
      "0": "Dat is de helft (0,50).",
      "1": "Dat is een kwart (0,25).",
      "3": "Dat is 0,40."
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 3,
        "denominator": 4,
        "label": "3 van de 4 stukken",
        "visualType": "pizza",
        "usePizza": true
      },
      "showWhen": "always"
    }
  },
  {
    "id": "GET-VER-L1-003",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Je hebt 1 taart. Je eet $\\frac{1}{4}$ deel op. Hoeveel is er over?",
    "options": [
      "$\\frac{3}{4}$",
      "$\\frac{1}{4}$",
      "$\\frac{1}{2}$",
      "$\\frac{4}{3}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "Een hele taart is $\\frac{4}{4}$. Je eet $\\frac{1}{4}$ op. Dan blijft er over: $\\frac{4}{4}$ - $\\frac{1}{4}$ = $\\frac{3}{4}$.",
    "distractorExplanations": {
      "1": "Dit is het stukje dat je hebt opgegeten! De vraag is: hoeveel blijft er over?",
      "2": "De helft is $\\frac{2}{4}$. Maar er blijft meer over dan de helft!",
      "3": "De onderkant (noemer) verandert niet. En $\\frac{4}{3}$ is meer dan 1 hele taart!"
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 3,
        "denominator": 4,
        "label": "3 van de 4 stukken zijn over",
        "visualType": "cake",
        "usePizza": true
      },
      "showWhen": "always"
    }
  },
  {
    "id": "GET-VER-L1-004",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Reken uit: $\\frac{2}{5}$ + $\\frac{1}{5}$ =",
    "options": [
      "$\\frac{3}{5}$",
      "$\\frac{3}{10}$",
      "$\\frac{2}{10}$",
      "$\\frac{1}{5}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_optellen",
    "familyId": "GET-BREUK-OPTELLEN",
    "explanation": "De onderkant is hetzelfde (beide 5). Tel alleen de bovenkant op: 2 + 1 = 3. Dus $\\frac{3}{5}$.",
    "distractorExplanations": {
      "1": "Je hebt de onderkant ook opgeteld (5 + 5 = 10). Maar de onderkant blijft gewoon 5!",
      "2": "Je hebt vermenigvuldigd. Maar bij breuken optellen tel je de bovenkant op.",
      "3": "Je hebt afgetrokken. Maar er staat een plusteken (+)!"
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 3,
        "denominator": 5,
        "label": "3 van de 5 stukken",
        "visualType": "chocolate",
        "usePizza": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-AFT-L1-001",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Reken uit: 456 - 123 =",
    "options": [
      "333",
      "323",
      "433",
      "579"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-ZONDER",
    "explanation": "Reken kolom voor kolom: 6 - 3 = 3, 5 - 2 = 3 en 4 - 1 = 3. Het antwoord is 333.",
    "distractorExplanations": {
      "1": "Kijk goed naar de tientallen: 5 - 2 = 3, niet 2.",
      "2": "Je bent vergeten de honderdtallen af te trekken.",
      "3": "Je hebt de getallen opgeteld in plaats van afgetrokken."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Kolomsgewijs",
        "content": "Begin bij de eenheden (rechts) en werk naar links.",
        "icon": "calculator"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-AFT-L1-002",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Reken uit: 789 - 345 =",
    "options": [
      "444",
      "344",
      "434",
      "1134"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-ZONDER",
    "explanation": "Trek van rechts naar links af: 9 - 5 = 4, 8 - 4 = 4 en 7 - 3 = 4. Samen 444.",
    "distractorExplanations": {
      "1": "Rekenfoutje bij de honderdtallen: 7 - 3 = 4.",
      "2": "Check de tientallen nog eens: 8 - 4 = 4.",
      "3": "Je hebt opgeteld!"
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Tip",
        "content": "Trek elk cijfer van de juiste kolom af.",
        "icon": "info"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-VGL-L1-001",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Welke breuk is groter: $\\frac{1}{2}$ of $\\frac{1}{4}$?",
    "options": [
      "$\\frac{1}{2}$",
      "$\\frac{1}{4}$",
      "Ze zijn even groot",
      "Kan je niet zeggen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "$\\frac{1}{2}$ is groter dan $\\frac{1}{4}$. Denk aan een pizza: als je hem in 2 stukken snijdt, is een stuk veel groter dan wanneer je hem in 4 stukken snijdt!",
    "distractorExplanations": {
      "1": "Een kwart is kleiner dan een half!",
      "2": "Ze zijn niet even groot. Een half is twee keer zo groot als een kwart.",
      "3": "Je kunt het wel zeggen! Vergelijk de grootte van de stukken."
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 1,
        "denominator": 2,
        "label": "1/2 is meer dan 1/4",
        "visualType": "pizza",
        "usePizza": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-VGL-L1-002",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Welke breuk is kleiner: $\\frac{2}{3}$ of $\\frac{2}{5}$?",
    "options": [
      "$\\frac{2}{5}$",
      "$\\frac{2}{3}$",
      "Ze zijn even groot",
      "Kan je niet zeggen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "$\\frac{2}{5}$ is kleiner. Als de bovenkant hetzelfde is, kijk naar de onderkant. Hoe groter de onderkant, hoe kleiner de stukken!",
    "distractorExplanations": {
      "1": "$\\frac{2}{3}$ is juist groter! 2 van de 3 is meer dan 2 van de 5.",
      "2": "Ze zijn niet even groot. $\\frac{2}{3}$ is groter.",
      "3": "Je kunt het wel vergelijken door naar de onderkant te kijken."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Breukenregel",
        "content": "Gelijke bovenkant? De grootste onderkant geeft de kleinste stukjes.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-OPT-L1-001",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Reken kolomsgewijs uit: 342 + 526 =",
    "options": [
      "868",
      "768",
      "878",
      "968"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-ZONDER",
    "explanation": "Reken van rechts naar links: 2 + 6 = 8, 4 + 2 = 6 en 3 + 5 = 8. Dus 868.",
    "distractorExplanations": {
      "1": "Kijk goed naar de honderdtallen: 3 + 5 = 8.",
      "2": "Rekenfoutje bij de voortallen: 4 + 2 = 6.",
      "3": "Je hebt te veel geteld bij de honderdtallen."
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 342,
        "operand2": 526,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-OPT-L1-002",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Reken kolomsgewijs uit: 534 + 312 =",
    "options": [
      "846",
      "746",
      "856",
      "946"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-ZONDER",
    "explanation": "Tel de kolommen op: 4+2=6, 3+1=4 en 5+3=8. Het antwoord is 846.",
    "distractorExplanations": {
      "1": "Honderdtallen: 5 + 3 = 8, niet 7.",
      "2": "Tientallen: 3 + 1 = 4, niet 5.",
      "3": "Check de honderdtallen nog eens."
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 534,
        "operand2": 312,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-POS-L1-002",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Wat is de waarde van de 6 in het getal 64.519?",
    "options": [
      "6.000",
      "60.000",
      "600",
      "600.000"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "positiewaarde",
    "familyId": "GET-POS-WAARDE",
    "explanation": "De 6 staat op de plek van de tienduizendtallen. Dat betekent 60.000.",
    "distractorExplanations": {
      "0": "Dat zijn de duizendtallen (de 4).",
      "2": "Dat zijn de honderdtallen (de 5).",
      "3": "Dat zou de plek van de honderdduizendtallen zijn."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Posities",
        "content": "H - T - E... maar bij tienduizendtallen komt er nog een plekje voor.",
        "icon": "hash"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-VGL-L1-003",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Welk getal is het grootst?",
    "options": [
      "8.905",
      "8.950",
      "8.590",
      "8.509"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "getallen_vergelijken",
    "familyId": "GET-GETAL-VGL",
    "explanation": "Vergelijk eerst de duizendtallen (allemaal 8). Kijk dan naar de honderdtallen: 900 is groter dan 500. Van de twee met 900 is 8.950 groter dan 8.905.",
    "distractorExplanations": {
      "0": "8.905 heeft 0 tientallen. 8.950 heeft er 5, dus die is groter.",
      "2": "8.590 heeft maar 5 honderdtallen. De 8.900 getallen zijn groter.",
      "3": "Dit is het kleinste getal in de lijst."
    }
  },
  {
    "id": "GET-VER-L1-005",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "In een doos zitten 12 koekjes. $\\frac{1}{3}$ daarvan is chocolade. Hoeveel chocoladekoekjes zijn dat?",
    "options": [
      "4",
      "3",
      "6",
      "8"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "Een derde betekent: deel de hele groep door 3. 12 : 3 = 4 chocoladekoekjes.",
    "distractorExplanations": {
      "1": "Je deelde door 4, maar een derde betekent delen door 3.",
      "2": "Dat is de helft (6). Een derde is kleiner dan de helft.",
      "3": "Dit is twee derde van de koekjes."
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 1,
        "denominator": 3,
        "label": "1 van de 3 groepjes",
        "visualType": "chocolate",
        "usePizza": false
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-OPT-L1-003",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Reken uit: 450 + 325 =",
    "options": [
      "775",
      "875",
      "725",
      "755"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-ZONDER",
    "explanation": "Honderdtallen: 400 + 300 = 700. Tientallen en eenheden: 50 + 25 = 75. Samen 775.",
    "distractorExplanations": {
      "1": "Je telde 100 te veel bij de honderdtallen.",
      "2": "Je bent de 50 van het eerste getal vergeten.",
      "3": "Rekenfoutje bij de tientallen: 50 + 20 = 70."
    }
  },
  {
    "id": "GET-AFT-L1-003",
    "module": "Getalbegrip",
    "difficulty": 103,
    "question": "Reken uit: 980 - 450 =",
    "options": [
      "530",
      "430",
      "550",
      "580"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-ZONDER",
    "explanation": "Trek de honderdtallen af: 900 - 400 = 500. Trek de tientallen af: 80 - 50 = 30. Dus 530.",
    "distractorExplanations": {
      "1": "Honderdtallen: 9 - 4 = 5, niet 4.",
      "2": "Tientallen: 8 - 5 = 3, niet 5.",
      "3": "Je bent vergeten de tientallen af te trekken."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Honderdtallen",
        "content": "Trek eerst de honderdtallen af, daarna de tientallen.",
        "icon": "info"
      },
      "showWhen": "wrong"
    }
  }
]
